import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logAction } from './auditLogSlice';

export interface AuthUser {
  email: string;
  role: 'merchant' | 'wave' | 'bank';
  merchantId?: string;
  /** Privileges from User Management (resource:action). Used to filter menu and route access. */
  privileges?: string[];
}

interface AuthState {
  isAuthenticated: boolean;
  user: AuthUser | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<AuthUser>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    setUserPrivileges: (state, action: PayloadAction<string[]>) => {
      if (state.user) state.user.privileges = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

export const { login: loginAction, setUserPrivileges, logout: logoutAction } = authSlice.actions;

export const login = (credentials: AuthUser): any => (dispatch: any) => {
    dispatch(loginAction(credentials));
    dispatch(logAction({ user: credentials.email, action: `User Logged In (${credentials.role})` }));
};

export const logout = (): any => (dispatch: any, getState: any) => {
    const user = getState().auth.user?.email || 'System';
    dispatch(logAction({ user, action: 'User Logged Out' }));
    dispatch(logoutAction());
};

export default authSlice.reducer; 